// AuthProvider.js
import React, { createContext, useState, useEffect, useContext } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebaseConfig'; // Adjust path as needed
import axios from 'axios';
import { jwtDecode } from 'jwt-decode'; // Ensure this is the correct import

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authState, setAuthState] = useState({
    token: localStorage.getItem('token'),
    isLoggedIn: !!localStorage.getItem('token'),
  });

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const token = await user.getIdToken();
        const isExpired = isTokenExpired(token);
        if (!isExpired) {
          localStorage.setItem('token', token);
          setAuthState({
            token,
            isLoggedIn: true,
          });
        }
      } else {
        localStorage.removeItem('token');
        setAuthState({
          token: null,
          isLoggedIn: false,
        });
      }
    });

    return () => unsubscribe();
  }, []);

  const isTokenExpired = (token) => {
    try {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      return decodedToken.exp < currentTime;
    } catch (error) {
      console.log(error);
      console.error('Invalid token:', error);
      return true; // Invalid token
    }
  };

  const refreshToken = async () => {
    if (!isTokenExpired(authState.token)) {
      return;
    }

    try {
      const response = await axios.post(`${process.env.REACT_APP_FLASK_API_URL}/api/refresh`, {}, {
        headers: {
          'Authorization': `Bearer ${authState.token}`,
        },
      });

      const newToken = response.data.access_token;
      localStorage.setItem('token', newToken);
      setAuthState((prevState) => ({
        ...prevState,
        token: newToken,
      }));
    } catch (error) {
      console.error('Error refreshing token:', error);
    }
  };

  return (
    <AuthContext.Provider value={{ authState, setAuthState, refreshToken }}>
      {children}
    </AuthContext.Provider>
  );
};

export function useAuth() {
  return useContext(AuthContext);
}
